import {
  ElectronicAccessDto,
  ElectronicAccessDtoWithURI,
} from '@app/components';

export const processElectronicAccess = (
  electronicAccess: ElectronicAccessDto[] = []
) =>
  electronicAccess
    .filter((value): value is ElectronicAccessDtoWithURI => Boolean(value?.uri))
    .map(value => ({
      ...value,
      linkText: value.linkText || value.uri,
    }));
